<template>
  <div class="d-flex" :style="{ padding: '10px' }">
    <v-card
      class="d-flex pa-2 flex-column"
      :style="{ 'margin-bottom': '40px', width: '100%', height: '550px' }"
    >
      <div
        class="d-flex pa-2 flex-column"
        :style="{ width: '100%', height: '10px' }"
      >
        Route
      </div>
      <div class="d-flex pa-2" :style="{ width: '100%', height: '500px' }">
        <div class="d-flex pa-2 flex-column" :style="{ flex: '5' }">
          <v-text-field :style="{ flex: '1' }" />
          <label for="selectedLeft"></label>
          <select
            v-model="selectedLeft"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedLeft"
          >
            <optgroup label="Routes" v-if="itemsLeft.length != 0">
              <option v-for="(item, i) in itemsLeft" :key="i">
                {{ item }}
              </option>
            </optgroup>
          </select>
        </div>
        <div
          class="d-flex pa-2 flex-column justify-center align-center"
          :style="{ flex: '1' }"
        >
          <v-btn color="warning" class="mb-2"
            ><v-icon>mdi-refresh</v-icon></v-btn
          >
          <v-btn color="red" class="mb-2" @click="toLeft"
            ><v-icon>mdi-chevron-double-left</v-icon></v-btn
          >
          <v-btn color="success" class="mb-2" @click="toRight"
            ><v-icon>mdi-chevron-double-right</v-icon></v-btn
          >
        </div>
        <div class="d-flex pa-2 flex-column" :style="{ flex: '5' }">
          <v-text-field :style="{ flex: '1' }" />
          <label for="selectedRight"></label>
          <select
            v-model="selectedRight"
            multiple
            class="d-flex pa-2 flex-column"
            :style="{ overflow: 'scroll', flex: '9' }"
            id="selectedRight"
          >
            <optgroup label="Routes" v-if="itemsRight.length != 0">
              <option v-for="(item, i) in itemsRight" :key="i">
                {{ item }}
              </option>
            </optgroup>
          </select>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data: () => ({
    benched: 0,
    selectedLeft: [],
    selectedRight: [],
    itemsLeft: ['rbac/route', 'rbac/user', 'rbac/permission', 'rbac/*'],
    itemsRight: ['user/index', 'user/update', 'user/delete', 'user/*'],
  }),
  computed: {},
  methods: {
    toRight() {
      if (this.selectedLeft.length > 0) {
        this.itemsRight = this.itemsRight.concat(this.selectedLeft);
        this.itemsLeft = this.itemsLeft.filter(
          (x) => !this.itemsRight.includes(x)
        );
        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },
    toLeft() {
      if (this.selectedRight.length > 0) {
        this.itemsLeft = this.itemsLeft.concat(this.selectedRight);
        this.itemsRight = this.itemsRight.filter(
          (x) => !this.itemsLeft.includes(x)
        );
        this.selectedLeft = [];
        this.selectedRight = [];
      }
    },
  },
};
</script>
